var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"store-header-loading",attrs:{"aria-hidden":"true"}}):_c(_vm.headerComponent,{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }